import './style.scss'
import { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import { GridContainer, FlexRow, Circle, AppSpan, AppText, AbsoluteContainer, CustomContainer } from "src/style"
import { GiCheckMark } from 'react-icons/gi'
import { onboardingProgressBarLength } from 'src/utils/utility'
import { Design } from 'src/model'
//import { FiChevronLeft } from 'react-icons/fi'

export const OnboardingProcessBar: React.FC<any> = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const {info} = useContext(AppInfoContext)
    const [onboardingType, setOnboardingType] = useState(info.onboardingType)
    const [stepsStatus, setStepsStatus] = useState(info.onboardingProcessStatus)

    let isRfsFlow = info.institutionData.onboardingFlow === 'RFS'

    useEffect(() => {
        if (info.onboardingType) setOnboardingType(info.onboardingType)
    }, [info.onboardingType])

    useEffect(() => {
        if (info.onboardingProcessStatus) setStepsStatus(info.onboardingProcessStatus)
    }, [info.onboardingProcessStatus])
    
    return (
        <CustomContainer 
            topPadding={info.institutionData?.design === Design.DESIGN_2 ? '18' : '5'} 
            bottomMargin={info.institutionData?.design === Design.DESIGN_2 ? '3' : '6'} 
            className='o-progressbar-wrapper'
        >
            {/* <AbsoluteContainer left='2.5' bottom='3' onClick={() => navigate(-1)}>
                <AppSpan textSize='2.5' hoverColor='#0D968F'>
                    <FiChevronLeft/>
                </AppSpan>
            </AbsoluteContainer> */}
            <GridContainer className='scrollable-container'>
                <FlexRow gap='2' width="auto" sizeUnit="">
                    <AbsoluteContainer top="1.3" leftMargin="0" width="100" sizeUnit="%">
                        <GridContainer>
                            <CustomContainer width={onboardingType === 'new-user' ? "55" : '34'} height="0.2" bgColor="#EAECF0">
                                <CustomContainer 
                                    height='0.2' 
                                    width={onboardingProgressBarLength(location.pathname)} 
                                    sizeUnit='%' bgColor='#0D968F' 
                                />
                            </CustomContainer>
                        </GridContainer>
                    </AbsoluteContainer>
                    <GridContainer width="15" style={{zIndex: '2'}} >
                        <Circle 
                            size='2.4' bottomMargin="1.3"
                            bgColor={(stepsStatus?.isBvnVerified || location.pathname.includes('/bvn-verification')) ? '#E7F6F5' : '#F9FAFB'}
                            borderColor={(stepsStatus?.isBvnVerified || location.pathname.includes('/bvn-verification')) ? '#F4EBFF' : 'none'}
                            borderWidth={(stepsStatus?.isBvnVerified || !location.pathname.includes('/bvn-verification')) ? '1' : '3'}
                        >
                            { stepsStatus?.isBvnVerified ?
                                <AppSpan textSize="1.2" color="#0D968F"><GiCheckMark /></AppSpan>
                                :
                                <Circle 
                                    size='0.8' 
                                    bgColor={location.pathname.includes('/bvn-verification') ? '#0D968F' : '#EAECF0'}
                                />
                            }
                        </Circle>
                        <AppText 
                            fontWeight='600' 
                            color={(!stepsStatus?.isBvnVerified && location.pathname.includes('/bvn-verification')) ? '#0A756F' : '#344054'}
                        >
                            Verify {isRfsFlow ? 'Email' : 'BVN'}
                        </AppText>
                    </GridContainer>
                    
                    { onboardingType === 'new-user' &&
                        <GridContainer width="15" style={{zIndex: '2'}} >
                            <Circle 
                                size='2.4' bottomMargin="1.3"
                                bgColor={(stepsStatus?.isUserVerified || location.pathname.includes('/user-verification')) ? '#E7F6F5' : '#F9FAFB'}
                                borderColor={(stepsStatus?.isUserVerified || location.pathname.includes('/user-verification')) ? '#F4EBFF' : 'none'}
                                borderWidth={(stepsStatus?.isUserVerified || !location.pathname.includes('/user-verification')) ? '1' : '3'}
                            >
                                { stepsStatus?.isUserVerified ?
                                    <AppSpan textSize="1.2" color="#0D968F"><GiCheckMark /></AppSpan>
                                    :
                                    <Circle 
                                        size='0.8' 
                                        bgColor={location.pathname.includes('/user-verification') ? '#0D968F' : '#EAECF0'}
                                    />
                                }
                            </Circle>
                            <AppText 
                                fontWeight='600' 
                                color={(!stepsStatus?.isUserVerified && location.pathname.includes('/user-verification')) ? '#0A756F' : '#344054'}
                            >
                            Verify Identity
                            </AppText>
                        </GridContainer>
                    }
                    <GridContainer width="15" style={{zIndex: '2'}} >
                        <Circle 
                            size='2.4' bottomMargin="1.3"
                            bgColor={(stepsStatus?.isConfirmedInfo || location.pathname.includes('/info-confirmation')) ? '#E7F6F5' : '#F9FAFB'}
                            borderColor={(stepsStatus?.isConfirmedInfo || location.pathname.includes('/info-confirmation')) ? '#F4EBFF' : 'none'}
                            borderWidth={(stepsStatus?.isConfirmedInfo || !location.pathname.includes('/info-confirmation')) ? '1' : '3'}
                        >
                            { stepsStatus?.isConfirmedInfo ?
                                <AppSpan textSize="1.2" color="#0D968F"><GiCheckMark /></AppSpan>
                                :
                                <Circle 
                                    size='0.8' 
                                    bgColor={location.pathname.includes('/info-confirmation') ? '#0D968F' : '#EAECF0'}
                                />
                            }
                        </Circle>
                        <AppText 
                            fontWeight='600' 
                            color={(!stepsStatus?.isConfirmedInfo && location.pathname.includes('/info-confirmation')) ? '#0A756F' : '#344054'}
                        >
                            Confirm Information
                        </AppText>
                    </GridContainer>
                    {/* { onboardingType === 'new-user' &&
                        <GridContainer width="15" style={{zIndex: '2'}} >
                            <Circle 
                                size='2.4' bottomMargin="1.3"
                                bgColor={(stepsStatus?.isIdentityVerified || location.pathname.includes('/identity-verification')) ? '#E7F6F5' : '#F9FAFB'}
                                borderColor={(stepsStatus?.isIdentityVerified || location.pathname.includes('/identity-verification')) ? '#F4EBFF' : 'none'}
                                borderWidth={(stepsStatus?.isIdentityVerified || !location.pathname.includes('/identity-verification')) ? '1' : '3'}
                            >
                                { stepsStatus?.isIdentityVerified ?
                                    <AppSpan textSize="1.2" color="#0D968F"><GiCheckMark /></AppSpan>
                                    :
                                    <Circle 
                                        size='0.8' 
                                        bgColor={location.pathname.includes('/identity-verification') ? '#0D968F' : '#EAECF0'}
                                    />
                                }
                            </Circle>
                            <AppText 
                                fontWeight='600' 
                                color={(!stepsStatus?.isIdentityVerified && location.pathname.includes('/identity-verification')) ? '#0A756F' : '#344054'}
                            >
                            Verify Identity
                            </AppText>
                        </GridContainer>
                    } */}
                    <GridContainer width="15" style={{zIndex: '2'}} >
                        <Circle 
                            size='2.4' bottomMargin="1.3"
                            bgColor={(stepsStatus?.isCredentialsCreated || location.pathname.includes('/credentials-creation')) ? '#E7F6F5' : '#F9FAFB'}
                            borderColor={(stepsStatus?.isCredentialsCreated || location.pathname.includes('/credentials-creation')) ? '#F4EBFF' : 'none'}
                            borderWidth={(stepsStatus?.isCredentialsCreated || !location.pathname.includes('/credentials-creation')) ? '1' : '3'}
                        >
                            { stepsStatus?.isCredentialsCreated ?
                                <AppSpan textSize="1.2" color="#0D968F"><GiCheckMark /></AppSpan>
                                :
                                <Circle 
                                    size='0.8' 
                                    bgColor={location.pathname.includes('/credentials-creation') ? '#0D968F' : '#EAECF0'}
                                />
                            }
                        </Circle>
                        <AppText 
                            fontWeight='600' 
                            color={(!stepsStatus?.isCredentialsCreated && location.pathname.includes('/credentials-creation')) ? '#0A756F' : '#344054'}
                        >
                            {(isRfsFlow && onboardingType === 'new-user') ? 'Referral' : 'Create Credentials'}
                        </AppText>
                    </GridContainer>
                </FlexRow>
            </GridContainer>
        </CustomContainer>
    )
}